import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-checkbox-cell-renderer',
  templateUrl: './checkbox-cell-renderer.component.html',
  styleUrl: './checkbox-cell-renderer.component.scss',
  standalone: true,
})
export class CheckboxCellRendererComponent implements ICellRendererAngularComp {
  params: ICellRendererParams;
  checked = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.checked = !!params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.checked = !!params.value;
    return true;
  }

  onCheckboxChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const isChecked = input.checked;

    // Update the cell value
    this.params.node.setDataValue(this.params.colDef.field!, isChecked);

    // Update row selection state
    this.params.node.setSelected(isChecked);

    // Sync internal checkbox state
    this.checked = isChecked;
  }
}
